export const DEBOUNCE_TIMER = 500

export const baseApiEndpoint = {
  production: "https://campaya.com",
  development: "http://localhost.campaya.dk",
  staging: "https://dev01.campaya.com",
  vite: "http://localhost:5000"
};


export const getBaseEndpoint = () => {
  // return nothing so that the api's will call their own domain and not encounter CORS errors
  return ""
}

export const BaseCdnUrl = import.meta.env.VITE_CDN_BASE_URL;

